<template>
  <section id="snapsheets-options-container">
    <template v-if="templates && templates.length">
      <SnapsheetsTemplatesItem
        v-for="template in templates"
        :key="'ssitem-' + template.id"
        :template="template"
      />
    </template>

    <template v-else>
      <div>No results</div>
    </template>
  </section>
</template>

<script>
import SnapsheetsTemplatesItem from "@/components/Dashboard/SnapsheetsTemplates/SnapsheetsTemplatesItem.vue";
export default {
  name: "SnapsheetsTemplatesContainer",

  components: { SnapsheetsTemplatesItem },

  props: ["templates"],
};
</script>

<style lang="scss" scoped>
#snapsheets-options-container {
  display: grid;
  gap: 4rem;
  padding: 0 5%;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>